module.exports = __webpack_public_path__ + "650b504359e8d0851adc2443285de4f4.svg";